import 'angular';
import {uibModalInstance} from '../types/angular-ui-types';
import "../share-modal/shared_by_me_resource_filter_dialog.html";

    angular.module('GorillaBoy.FileBrowser')
    .controller('FilterSharedByMeResourceController', [
        '$scope',
        '$translate',
        '$uibModalInstance',
        FilterSharedByMeResourceController
    ]);
    
    function FilterSharedByMeResourceController($scope:ng.IRootScopeService, $translate: ng.translate.ITranslateService, $uibModalInstance: uibModalInstance) {
    	let RESOURCE_SHARE_CATEGORY = {
    		ALL: {
        	name: 'ALL',
        	title: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_ALL'),
        	detail: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_ALL')
        },	
    		SHARED_BY_INVITE: {
    			name: 'SHARED_WITH_ME',
    			title: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_SHARED_BY_INVITE'),
    			detail: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_SHARED_BY_INVITE')
    		},
    		SHAREABLE_LINK: {
    			name: 'SHAREABLE_LINK',
    			title: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_SHAREABLE_LINK'),
    			detail: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_SHAREABLE_LINK')
    		},
    		ANONYMOUS_LINK: {
    			name: 'ANONYMOUS_LINK',
    			title: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_ANONYMOUS_LINK'),
    			detail: $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_ANONYMOUS_LINK')
    		}
    	};
    	const EPOCH_BASE = 1000;
    	
    	activate();
    	
    	function activate(){
    		$scope.RESOURCE_SHARE_CATEGORY = RESOURCE_SHARE_CATEGORY;
	    	$scope.filter = {
	    	    category: RESOURCE_SHARE_CATEGORY.ALL.name,
	    	    startDate: null,
	    	    endDate: null,
	    	    startDateEnabled: false,
	    	    endDateEnabled: false
	    	};
	    	$scope.onShareCategoryFilterChange = function(op) {
	    		  $scope.filter.category = op.name;
	    	}
	    	
	    	$scope.startDateOptions = {
	    			minDate: -1000,
		        maxDate: 0,
		        showOn: 'button'
		    };
	    	
	    	$scope.endDateOptions = angular.copy($scope.startDateOptions)
	    	
	    	$scope.getCategoryDetailedMessage = function(){
	    		let categoryDetailedMessage = "",
	    			category = $scope.filter.category;
                switch(category){
                	case RESOURCE_SHARE_CATEGORY.ALL.name:
                		categoryDetailedMessage = RESOURCE_SHARE_CATEGORY.ALL.detail;
                		break;
                	case RESOURCE_SHARE_CATEGORY.SHARED_BY_INVITE.name:
                		categoryDetailedMessage = RESOURCE_SHARE_CATEGORY.SHARED_BY_INVITE.detail;
                		break;
                	case RESOURCE_SHARE_CATEGORY.SHAREABLE_LINK.name:
                		categoryDetailedMessage = RESOURCE_SHARE_CATEGORY.SHAREABLE_LINK.detail;
                		break;
                	case RESOURCE_SHARE_CATEGORY.ANONYMOUS_LINK.name:
                		categoryDetailedMessage = RESOURCE_SHARE_CATEGORY.ANONYMOUS_LINK.detail;
                		break;
                }

                return categoryDetailedMessage;
          };

          $scope.getCategoryTitle = function(){
        	  let categoryTitle = "",
                  category = $scope.filter.category;

        	  switch(category){
          		  case RESOURCE_SHARE_CATEGORY.ALL.name:
          			  categoryTitle = RESOURCE_SHARE_CATEGORY.ALL.title;
          			  break;
          		  case RESOURCE_SHARE_CATEGORY.SHARED_BY_INVITE.name:
          			  categoryTitle = RESOURCE_SHARE_CATEGORY.SHARED_BY_INVITE.title;
          			  break;
          		  case RESOURCE_SHARE_CATEGORY.SHAREABLE_LINK.name:
          			  categoryTitle = RESOURCE_SHARE_CATEGORY.SHAREABLE_LINK.title;
          			  break;
          		  case RESOURCE_SHARE_CATEGORY.ANONYMOUS_LINK.name:
          			  categoryTitle = RESOURCE_SHARE_CATEGORY.ANONYMOUS_LINK.title;
          			  break;
          }

            return categoryTitle;
        };
        
	    $scope.showStartDateCalendar = function() {
	    	if (!$scope.filter.startDate){
	    		$scope.filter.startDateEnabled = false;
	    		$scope.showStartDatepicker();
	    	} else {
	    		if ($scope.filter.startDateEnabled === false) {
	    			$scope.endDateOptions.minDate = -1000;
	    		} else {
	    			$scope.endDateOptions.minDate = $scope.filter.startDate;
	    		}
	    	}
	    };
	    
        $scope.showStartDatepicker = function() {
	    	($('#filter-start-date') as any).datepicker('show');
	    };
	    	
	    $scope.showEndDateCalendar = function() {
	    	if (!$scope.filter.endDate){
	    		$scope.filter.endDateEnabled = false;
	    		$scope.showEndDatepicker();
	    	} else {
	    		if ($scope.filter.endDateEnabled === false) {
	    			$scope.startDateOptions.maxDate = 0;
	    		} else {
	    			$scope.startDateOptions.maxDate = $scope.filter.endDate;
	    		}
	    	}
	    };
	    
        $scope.showEndDatepicker = function() {
	    	($('#filter-end-date') as any).datepicker('show');
	    };
	    	
        $scope.$watch('filter.startDate', function(newValue, oldValue) {
            if (newValue) { // Set value
            	$scope.endDateOptions.minDate = newValue;
            	$scope.filter.startDateEnabled = true;
            } else if (oldValue && !newValue) { //Remove value
            	$scope.filter.startDateEnabled = false;
        	}
        }, true);

        $scope.$watch('filter.endDate', function(newValue, oldValue) {
            if (newValue) { // Set value
            	$scope.startDateOptions.maxDate = newValue;
            	$scope.filter.endDateEnabled = true;
            } else if (oldValue && !newValue) { //Remove value
            	$scope.filter.endDateEnabled = false;	
        	}
        }, true);

	    
	    $scope.submitFilter = function(shareForm) {
	    		$uibModalInstance.close({
	    			resourceCategory: $scope.filter.category,
	    			startTime: ($scope.filter.startDate && $scope.filter.startDateEnabled === true) ? $scope.filter.startDate : null,
	    			endTime: ($scope.filter.endDate && $scope.filter.endDateEnabled === true) ? $scope.filter.endDate : null
	    		});
	    	}
    	}
    	
    }
    